import Ads from "../pages/ads/Ads";

function AdsRoutes () {
    return [
        {
            path: '/ads',
            element: <Ads />
        }
    ];
}

export default AdsRoutes;